
import {Component, Vue} from "vue-property-decorator";
import {RequestPaging} from "@/utils/util";
import LsDialog from '@/components/ls-dialog.vue'
import LsPagination from '@/components/ls-pagination.vue'
import {apiActivityData} from '@/api/operating/group_welfare/activity'
@Component({
    components: {
        LsDialog,
        LsPagination
    }
})
export default class ActivityData extends Vue {
    dataTabs:any = {
        click_num: {
            key: 'click_num',
            name: '点击人数',
            desc: '指进入活动页面的人数',
            number: 0
        },
        browse_num: {
            key: 'browse_num',
            name: '曝光人数',
            desc: '指活动的展现人数',
            number: 0
        },
        orders_count: {
            key: 'orders_count',
            name: '订单数',
            desc: '',
            number: 0,
            link: '/operating/group_welfare/sale_order'
        },
        supply_amount: {
            key: 'supply_amount',
            name: '供货金额',
            desc: '指采购单供货金额实付合计',
            number: 0
        },
        sell_amount: {
            key: 'sell_amount',
            name: '代销金额',
            desc: '指代销销售单金额实付合计',
            number: 0
        },
        platform_commission: {
            key: 'platform_commission',
            name: '平台佣金',
            desc: '指平台扣点费用合计',
            number: 0
        },
        profit_amount: {
            key: 'profit_amount',
            name: '代销商利润',
            desc: '指代销商利润合计',
            number: 0
        },
    }
    id:any = ''
    info = {}
    lists = []
    pager = new RequestPaging()
    

    getData() {
        const loading = this.$loading({
            lock: true,
            text: '加载中...',
            spinner: 'el-icon-loading'
        })
        apiActivityData({id: this.id}).then(data => {
            loading.close()
            Object.keys(this.dataTabs).map(key => {
                let item = this.dataTabs[key];
                item.number = data[key]
                if (key == 'orders_count') {
                    item.link = '/operating/group_welfare/sale_order?activity_id='+this.id
                }
                this.$set(this.dataTabs, key, item)
            })
            this.info = data
        })
    }
    created() {
        this.id = this.$route.query.id;
        this.getData()
    }
}
